import EventDetailsForm from './EventDetailsForm'
export default EventDetailsForm